import React from 'react'
import { Link } from 'gatsby'
import { StaticQuery, graphql } from 'gatsby'
import Layout from '../components/layout'
import Beta from '../components/Beta'
import Helmet from 'react-helmet'
import firebase from "firebase";
import {
  FirebaseAuthProvider,
  IfFirebaseAuthed,
} from "@react-firebase/auth";
import { config } from "../../config";
import { translate } from "react-i18next"
import i18n from '../components/lang/i18n'

import qrcode from '../assets/images/qr-code.png'

class Meeting extends React.Component {
    constructor(props) {
        super(props);
        this.i18n = i18n;
        this.showMessage = this.showMessage.bind(this);
        this.handler = this.handler.bind(this)
        this.state = {
          message: "",
          isApp: false,
        };
      }
    
      handler() {
        this.setState({
          isApp: false,
        })
      }
  
    showMessage(message) {
        this.setState({
            message: message,
        });
    }

    render() {
        const { t } = this.props
        return (
        <StaticQuery
          query={graphql`
            query MeetingQuery {
              site {
                siteMetadata {
                  shortTitle,
                  admins
                }
              }
            }
          `}
          render={data => (
                        <Layout cl="" handler={this.handler}>
                            <Helmet>
                            <title>{data.site.siteMetadata.shortTitle} - Meeting</title>
                            <meta name="description" content="Du hast eine Einladung zu einem WFOW-Meeting erhalten oder möchtest einen Termin mit Hila vereinbaren? Dann bist du hier richtig." />
                            </Helmet> 
                            <div id="main">
                                <section id="one">
                                    <div className="inner">
                                        <div className="grid-wrapper">
                                            <div className="col-6">
                                                <header className="major">
                                                    <h2>{t("meeting_title", "Konferenzraum")}</h2>
                                                </header>
                                                <p>{t("meeting_subtitle", "Du hast eine Einladung zu einem WFOW-Meeting erhalten oder möchtest einen Termin mit Hila vereinbaren? Dann bist du hier richtig.")}</p>
                                                <a className="button next" href="https://us02web.zoom.us/j/87850039136?pwd=T3BMcVRUZ0s1UktzbUs1d2ZwbDFQUT09" target="_blank">{t("meeting_button", "Meeting starten")}</a>
                                                <br/><br/>
                                                <a className="button next" href="https://calendly.com/wordfullofwomen/" target="_blank">{t("meeting_calendly", "Termin buchen")}</a>
                                                <br/><br/>
                                                <br/><br/>
                                                
                                                <FirebaseAuthProvider {...config} firebase={firebase}>
                                                        <IfFirebaseAuthed>
                                                        {(user) => {
                                                        var admins = data.site.siteMetadata.admins;
                                                            if (admins.includes(user.user.email)) {
                                                            return (
                                                                <ul className="alt">
                                                                    <li>https://us02web.zoom.us/j/87850039136</li>
                                                                    <li>Meeting ID: 878 5003 9136</li>
                                                                    <li>Passcode: Women</li>
                                                                    <li>Host Key: 281471</li>
                                                                </ul>
                                                            )
                                                            }}}
                                                        </IfFirebaseAuthed>
                                                    </FirebaseAuthProvider>
                                                
                                                <br/>
                                            </div>
                                            <div className="col-2">
                                            </div>
                                            <div className="col-4">
                                                <img className="profilepic" src={qrcode} alt="QR-Code" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <Beta />
                            </div>
                        </Layout>
                )}
            />
        )
      }
} 
export default translate("Index")(Meeting)